import { useState, useEffect } from "react";
import { getCountAll } from "../../services/statistikaClanka.service";
import "./UkupnaPosjecenostClanka.css";

const UkupnaPosjecenostClanka = () => {
  const [ukupnoPosjeta, setUkupnoPosjeta] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const ucitajStatistiku = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getCountAll();
        setUkupnoPosjeta(response.data);
      } catch (error) {
        setError("Došlo je do greške pri učitavanju podataka");
      } finally {
        setLoading(false);
      }
    };

    ucitajStatistiku();
  }, []);

  if (loading) {
    return <div>Učitavanje podataka...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="ukupnaposjecenost-div">
          <h2 className="ukupnaposjecenost-h2">
            Ukupan broj posjeta svih članaka:
          </h2>
          <p className="ukupnaposjecenost-p">{ukupnoPosjeta}</p>
    </div>
  );
};

export default UkupnaPosjecenostClanka;
